import TicketHttp from "../../ticketHttp";

class PurchaseCostServices {
  
  // Create new purchase cost
  static async createPurchaseCost(data) {
    return TicketHttp.post('/purchase', data);
  }

  // Update existing purchase cost for movie & theatre
  static async updatePurchaseCost(movieId, theatreId, data) {
    return TicketHttp.update(`/purchase/${movieId}/${theatreId}`, data);
  }

  // Delete purchase cost entry
  static async deletePurchaseCost(movieId, theatreId) {
    console.log('movieId, theatreId',movieId, theatreId);
    return TicketHttp.delete(`/purchase/${movieId}/${theatreId}`);
  }

  // Get all purchase costs for a specific theatre
  static async getPurchaseCostsByTheatre(theatreId) {

    console.log('in the getPurchaseCostByTheatre', theatreId)
     // Encode the theatreId to ensure it's URL-safe
     const encodedTheatreId = encodeURIComponent(theatreId.trim());
     console.log('encodedTheatreId',encodedTheatreId);
    return TicketHttp.get(`/purchase/${encodedTheatreId}`);
  }
}

export default PurchaseCostServices;
